module.exports = __webpack_public_path__ + "static/media/microwaves.37a37125.svg";